import { useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateTime } from "luxon";
import {
  getLongDateFormat,
  getMomentLongDateFormat,
  getLocale,
} from "../../utils/luxonHelpers";
import { updateStartDate } from "../../stores/schedule/scheduleActions";
import BootstrapDateTimePicker from "../BootstrapDateTimePicker";

const ScheduleDatePicker = () => {
  const dispatch = useDispatch();
  const startDate = useSelector((state) => state.schedule.schedule.start_date);
  const dayJumpSize = useSelector(
    (state) => state.schedule.schedule.day_jump_size
  );

  const datePickerOptions = useMemo(() => {
    return {
      format: getMomentLongDateFormat(), // Use moment.js format for Bootstrap Datepicker
      locale: getLocale(),
      calendarWeeks: true,
      ignoreReadonly: true,
    };
  }, []);

  const handleUpdateDate = useCallback(
    (e) => {
      // Bootstrap datepicker returns a moment object
      let newStartDate;
      if (e.date && e.date._isAMomentObject) {
        // Convert moment to Luxon DateTime
        newStartDate = DateTime.fromJSDate(e.date.toDate());
      } else if (e.date instanceof Date) {
        newStartDate = DateTime.fromJSDate(e.date);
      } else if (e.date instanceof DateTime) {
        newStartDate = e.date;
      } else {
        return;
      }

      dispatch(updateStartDate(newStartDate));
    },
    [dispatch]
  );

  const handleClick = useCallback(
    (type) => {
      const currentDate =
        startDate instanceof DateTime ? startDate : DateTime.fromISO(startDate);
      let newDate;

      switch (type) {
        case "prev":
          newDate = currentDate.minus({ days: dayJumpSize });
          break;
        case "next":
          newDate = currentDate.plus({ days: dayJumpSize });
          break;
        default:
          return;
      }

      dispatch(updateStartDate(newDate));
    },
    [startDate, dayJumpSize, dispatch]
  );

  return (
    <div className="input-group">
      <div className="input-group-btn">
        <button className="btn btn-default" onClick={() => handleClick("prev")}>
          <i className="fa fa-chevron-left"></i>
        </button>
      </div>
      {startDate && (
        <BootstrapDateTimePicker
          value={(startDate instanceof DateTime
            ? startDate
            : DateTime.fromISO(startDate)
          ).toFormat(getLongDateFormat())}
          options={datePickerOptions}
          onChange={handleUpdateDate}
        />
      )}
      <div className="input-group-btn">
        <button className="btn btn-default" onClick={() => handleClick("next")}>
          <i className="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default ScheduleDatePicker;
